import React from 'react';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);

    // Collect customer context from sessionStorage
    let customerEmail = '';
    let customerName = '';
    let orderNumber = '';
    try {
      const orderData = sessionStorage.getItem('currentOrder');
      if (orderData) {
        const parsed = JSON.parse(orderData);
        customerEmail = parsed.email || '';
        customerName = parsed.customer_name || '';
        orderNumber = parsed.order_number || '';
      }
    } catch {}

    // Send error to backend
    try {
      fetch(`${API_BASE}/error-logs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_email: customerEmail,
          customer_name: customerName,
          order_number: orderNumber,
          page_url: window.location.href,
          error_message: error?.toString() || 'Unknown error',
          error_stack: error?.stack || '',
          component_stack: errorInfo?.componentStack || ''
        })
      }).catch(() => {});
    } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: '#fafafa' }}>
          <div style={{ maxWidth: '480px', width: '100%', textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.4rem', fontWeight: '600', marginBottom: '0.75rem', color: '#111' }}>
              Si è verificato un errore
            </h1>
            <p style={{ color: '#666', marginBottom: '2rem', fontSize: '0.95rem', lineHeight: '1.6' }}>
              Ci scusiamo per l'inconveniente. Prova a ricaricare la pagina e ripetere l'operazione.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '0.75rem 2.5rem',
                background: '#111',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.85rem',
                letterSpacing: '0.15em',
                textTransform: 'uppercase'
              }}
            >
              Ricarica Pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
